import BannerSlider from "@/src/components/HomePage/BannerSlider/BannerSlider";
import UniversityPrograms from "@/src/components/HomePage/UniversityPrograms/UniversityPrograms";
import WhyChoose from "@/src/components/HomePage/WhyChoose/WhyChoose";
import AdmissionProcess from "@/src/components/AdmissionProcess/AdmissionProcess";
import Advantages from "../components/HomePage/Advantages/Advantages";
import TrainingFormats from "../components/HomePage/TrainingFormats/TrainingFormats";
// import DigitalUniversity from "@/src/components/HomePage/DigitalUniversity/DigitalUniversity";

const HomePage = () => {
  return (
    <div className="home-page padding-top">
      <BannerSlider />
      <UniversityPrograms />
      <WhyChoose />
      <Advantages />
      <TrainingFormats />
      <AdmissionProcess />
      {/* <DigitalUniversity /> */}
    </div>
  );
};

export default HomePage;
